// eslint-disable-next-line no-shadow
export enum UploadAssetActions {
	CONTROL_NET = 'controlnet',
	CHANGE_IT = 'segment',
	FACELOCK = 'facelock',
	TRUE_TOUCH = 'true_touch',
	CHARACTER_STUDIO = 'character',
	FACE_SWAP = 'face_swap',
	FACE_SWAP_IMAGE = 'face_swap',
	FACE_SWAP_VIDEO = 'face_swap',
	LIP_SYNC = 'lip_sync',
	UPSCALE_8K = 'upscale',
	VIDEO_ANYONE = 'video_anyone',
	VIDEO_ANYONE_INPUT_IMAGE = 'video_anyone_input_image',
	VIDEO_ANYONE_END_FRAME = 'end_frame',
	FACE_REPLACE = 'face_replace',
	FACE_REPLACE_TARGET = 'face_replace_target',
	MUSIC_VIDEO = 'music_video',
	CLOTHING_CHANGE_INPUT = 'cloth_swap_input',
	CLOTHING_CHANGE_TARGET = 'cloth_swap_target',
	CLOTH_SWAP = 'cloth_swap',
	PRODUCT_PHOTO = 'product_photo',
	PRODUCT_PHOTO_BACKGROUND = 'product_photo_background',
	PRODUCT_PHOTO_COMPOSITE = 'product_photo_composite',
	PRODUCT_PHOTO_COMBINED = 'product_photo_combined',
	OBJECT_PLACEMENT = 'object_placement',
	INTERNAL = 'internal',
	IMAGE_REFERENCE_STYLE = 'reference_image',
}
